<template>
  <v-bottom-sheet v-model="isActive" scrollable persistent>
    <v-card>
      <v-card-title class="d-flex align-center justify-center px-4 sticky-title pb-3" style="background-color: #eee; border-bottom: 3px solid #dbdbdb;">
        <p class="mb-0" style="font-weight: 400;">NOTIFICAÇÕES</p>
      </v-card-title>
      <v-card-text class="main-container pa-5">
        <div v-if="isLoading">
          <v-skeleton-loader
            v-for="i in 3"
            :key="i"
            class="mx-auto mb-2"
            max-height="92"
            type="image"
          ></v-skeleton-loader>
        </div>
        <div v-if="notifications.length && !isLoading">
          <div
            v-for="(notification, index) in notifications"
            class="notification-list-item"
            :class="!notification.viewed ? 'new' : ''"
            :key="index"
            :style="{ borderRight: notification.type === 'CHAT_SERVICE_ORDER' ? '3px solid #dbdbdb' : '' }"
            @click="goToAction(notification)"
          >
            <div v-if="notification?.createdBy" class="user-data d-flex">
              <img
                v-if="notification.createdBy.picture_url"
                class="user-image"
                :src="notification.createdBy.picture_url"
              />
              <v-icon v-else class="user-image" size="16" style="background-color: #e3e3e3">mdi-account</v-icon>
              <p
                class="user-name mb-0"
                :class="!notification.viewed ? 'new' : ''"
              >
                {{ notification.createdBy.name }}
              </p>
            </div>
            <div
              v-else-if="notification.type === 'SYSTEM' || notification.type === 'SYSTEM_UPDATE'"
              class="user-data d-flex"
            >
              <img class="user-image" src="/favicon.ico" />
              <p
                class="user-name mb-0"
                :class="!notification.viewed ? 'new' : ''"
              >
                {{ notification.type === 'SYSTEM' ? 'Sistema CheckMotors' : 'Equipe CheckMotors' }} <v-icon color="#48b38b" size="14" style="margin-top: -3px; margin-left: 2px;">mdi-check-decagram</v-icon>
              </p>
            </div>
            <p class="subtitle">{{ notification.description }}</p>
            <div class="text-end mb-0 mt-1">
              <span v-if="!notification.viewed" class="new-field">Nova・</span>
              <span class="date-field" :class="!notification.viewed ? 'new' : ''">{{ formatNotificationDate(notification.created_at) }}</span>
            </div>
          </div>
          <v-btn
            v-if="hasMoreData"
            class="mt-4"
            color="primary"
            depressed
            block
            @click="loadMoreData"
            >+ Notificações</v-btn
          >
        </div>
        <div v-if="!isLoading && (!notifications || notifications.length === 0)" class="empty-state">
          <div>
            <v-icon size="40">mdi-bell-outline</v-icon>
          </div>
          <p class="no-notifications">Nenhuma notificação por enquanto.</p>
        </div>
      </v-card-text>
      <v-card-actions class="pt-6 pb-12" style="background-color: #eee;">
        <v-btn outlined color="gray" block @click="close">Voltar</v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import UserNotificationService from '@/services/api/userNotification';
import ServiceOrderService from '@/services/api/serviceOrder';
import dayjs from 'dayjs';

export default {
  name: 'ModalNotifications',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      notifications: [],
      currentPage: 1,
      size: 5,
      hasMoreData: false,
      isLoading: true,
    };
  },
  methods: {
    async goToAction(notification) {
      if (notification.type === 'CHAT_SERVICE_ORDER') {
        const { data } = await ServiceOrderService.getServiceOrderByHash(notification.reference_id);
        this.$emit('view', { id: data.id, shouldOpenChat: true });
        this.close();
      } else if (notification.type === 'SERVICE_ORDER') {
        this.$emit('view', { id: Number(notification.reference_id), shouldOpenChat: false });
        this.close();
      }
    },
    close() {
      const newNotificationsIds = this.notifications.filter((notification) => !notification.viewed).map((notification) => notification.id);
      this.$emit('close', newNotificationsIds);
      this.notifications = [];
      this.currentPage = 1;
      this.hasMoreData = false;
    },
    async getUserNotifications(reset = false) {
      this.isLoading = true;

      if (reset) {
        this.notifications = [];
      }

      try {
        const { data } = await UserNotificationService.getUserNotifications({ page: this.currentPage, size: this.size });

        this.notifications = [...this.notifications, ...data.rows];

        this.currentPage = data.currentPage || 1;
        const totalPages = data.totalPages || 1;
        this.hasMoreData = this.currentPage < totalPages;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    formatNotificationDate(date) {
      return dayjs(date).format('DD/MM/YYYY HH:mm');
    },
    shouldShowHr(itemIndex, totalLength) {
      return itemIndex < totalLength - 1;
    },
    loadMoreData() {
      if (this.hasMoreData) {
        this.currentPage += 1;
        this.getUserNotifications();
      }
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.currentPage = 1;
        this.getUserNotifications(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#notifications-container {
  border-radius: 8px;

  .v-bottom-sheet.v-dialog {
    border-radius: 8px;
  }
}

.sticky-title {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
}

.main-container {
  background-color: white;

  .notification-container {
    height: 350px;
    overflow-y: auto;
    padding-right: 5px;
  }
}

.notification-list-item {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f6f7f9;
  margin-bottom: 10px;

  &.new {
    background-color: #e3f0d7;
    border: 1px solid #8acf8f;
  }

  hr {
    border: 1px solid #999;
    margin-bottom: 10px;
  }

  .date-field {
    font-size: 12px;
    color: #999;
    font-weight: 400;
    margin-bottom: 0;

    &.new {
      color: #48b38b;
    }
  }

  .new-field {
    font-size: 12px;
    color: #48b38b;
    font-weight: 600;
  }

  .title {
    font-size: 16px !important;
    margin-bottom: 0;
  }

  .subtitle {
    font-size: 12px !important;
    font-weight: 600;
    line-height: 18px;
    color: #4a5568;
    margin-bottom: 0;
  }
}

.empty-state {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .no-notifications {
    margin-top: 14px;
    font-size: 14px;
    font-weight: 500;
    color: #718096;
  }
}

.user-data {
  display: flex;
  margin-bottom: 10px;
  align-items: center;

  .user-image {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .user-name {
    font-size: 12px;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0;

    &.new {
      color: #255a6d;
    }
  }
}
</style>
